<template>
  <div class="card">
    <div class="card__image">
      <router-link :to="translations.i18nRoute({ name: 'product', params: { productSlug: product.slug } })">
        <img :src="product.images.edges[0].node.image" :alt="product.name">
      </router-link>
      <svg @click="overwriteWishlist" xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24" fill="none">
        <path d="M25.8423 10.9565C23.9255 14.788 18.2675 18.5313 18.2675 18.5313C18.2675 18.5313 12.2917 14.8767 10.3322 10.9565C9.61098 9.51363 9.48778 7.73177 10.3319 6.26727C11.2134 4.73809 12.5347 4.10303 14.2997 4.10303C17.1858 4.10303 17.9063 6.26727 18.2675 6.26727C18.6287 6.26727 19.3501 4.10303 21.875 4.10303C23.5178 4.10303 25.0214 4.84434 25.8423 6.26727C26.687 7.73145 26.5641 9.51363 25.8423 10.9565Z" :fill="isProductInWishlist ? 'white' : 'none'" stroke="white" stroke-width="1"/>
        <path d="M12.4173 20.3348C12.0829 20.6955 11.6669 21.1239 11.0533 21.4169C9.64922 22.0874 7.92714 21.5372 6.72478 21.4169C5.52243 21.2967 8.32669 20.5371 9.24973 20.3348C10.4659 20.0682 12.4173 20.3348 12.4173 20.3348C11.7885 20.0581 11.2165 19.8051 10.784 19.6134C10.285 19.3922 9.97185 19.2527 9.97185 19.2527C9.12997 18.7716 8.41497 18.2905 7.8069 17.8095C7.8069 17.8095 6.57743 18.7532 5.64266 18.892C4.49366 19.0626 1.67489 18.1706 2.75701 18.1706C3.38698 18.1706 3.95311 17.6161 4.56054 17.4492C5.87285 17.0884 7.8069 17.8095 7.8069 17.8095C7.40039 17.4879 7.04167 17.1663 6.72478 16.8446C6.09403 16.2045 5.62901 15.5644 5.28271 14.9242C5.14542 14.6704 5.02546 14.4159 4.92125 14.1608C4.92125 14.1608 2.87184 14.0535 2.0357 13.1207C1.23235 12.2245 0.59281 9.51361 1.31432 10.235C2.03583 10.9564 2.39661 10.9564 3.11772 11.6778C3.83882 12.3993 4.92125 14.1608 4.92125 14.1608C4.43922 12.9809 4.29427 11.7883 4.33036 10.5957C4.35222 9.87337 4.44051 9.15103 4.56054 8.43149C4.56669 8.39465 4.57294 8.35813 4.57929 8.32193C4.57929 8.32193 3.54172 7.88813 3.11772 7.34937C2.41536 6.45691 2.52885 4.00758 2.75701 4.46372C3.11786 5.18513 3.42895 5.33408 3.83927 5.90654C4.47672 6.7959 4.57929 8.32193 4.57929 8.32193C4.86998 6.66403 5.44928 5.52865 5.64342 5.18513C5.64342 5.18513 5.41583 4.06291 5.64339 3.38158C6.00483 2.29944 8.16834 1.57805 8.16761 1.21736C8.16561 0.231308 8.26727 2.86992 7.80763 3.74229C7.27836 4.74681 5.64342 5.18513 5.64342 5.18513C5.44928 5.52865 4.86998 6.66403 4.57929 8.32193C4.57294 8.35813 4.56669 8.39465 4.56054 8.43149C4.44051 9.15103 4.35222 9.87337 4.33036 10.5957C4.33036 10.5957 4.78423 8.77649 5.64266 8.07078C6.1293 7.67073 6.80367 7.91279 7.08549 7.34937C7.44633 6.62796 7.10293 9.16315 6.36408 9.87432C5.75693 10.4587 4.33036 10.5957 4.33036 10.5957C4.29427 11.7883 4.43922 12.9809 4.92125 14.1608C5.02546 14.4159 5.14542 14.6704 5.28271 14.9242C5.62901 15.5644 6.09403 16.2045 6.72478 16.8446C6.72478 16.8446 6.36408 15.4978 6.36408 14.5635C6.36408 13.4814 6.72478 13.1207 6.72478 12.0386C6.72478 10.9564 7.66349 12.9081 7.8069 13.8421C8.01631 15.2058 6.72478 16.8446 6.72478 16.8446C7.04167 17.1663 7.40039 17.4879 7.8069 17.8095C8.41497 18.2905 9.12997 18.7716 9.97185 19.2527C9.97185 19.2527 10.285 19.3922 10.784 19.6134C10.784 19.6134 10.7856 19.6051 10.7884 19.5895C10.6705 19.44 9.91619 18.7268 9.61043 17.8095C9.24973 16.7274 9.61043 15.9149 9.61043 15.2849C9.61043 14.2028 10.526 16.2887 10.784 17.0884C11.065 17.9592 10.8245 19.3879 10.7884 19.5895C10.8096 19.6164 10.8102 19.625 10.784 19.6134C11.2165 19.8051 11.7885 20.0581 12.4173 20.3348Z" fill="#F3F3F3"/>
        <path d="M20.8389 23.7245C20.662 23.7245 14.5631 21.279 12.4173 20.3348M5.64342 5.18513C5.64342 5.18513 5.41583 4.06291 5.64339 3.38158C6.00483 2.29944 8.16834 1.57805 8.16761 1.21736C8.16561 0.231308 8.26727 2.86992 7.80763 3.74229C7.27836 4.74681 5.64342 5.18513 5.64342 5.18513ZM5.64342 5.18513C5.44927 5.52865 4.86998 6.66403 4.57929 8.32193M12.4173 20.3348C12.0829 20.6955 11.6669 21.1239 11.0533 21.4169C9.64922 22.0874 7.92714 21.5372 6.72478 21.4169C5.52243 21.2967 8.32669 20.5371 9.24973 20.3348C10.4659 20.0682 12.4173 20.3348 12.4173 20.3348ZM12.4173 20.3348C11.7885 20.0581 11.2165 19.8051 10.784 19.6134M10.784 19.6134C10.285 19.3922 9.97185 19.2527 9.97185 19.2527C9.12997 18.7716 8.41497 18.2905 7.8069 17.8095M10.784 19.6134C10.784 19.6134 11.0868 18.0269 10.784 17.0884C10.526 16.2887 9.61043 14.2028 9.61043 15.2849C9.61043 15.9149 9.24973 16.7274 9.61043 17.8095C9.97114 18.8916 10.9561 19.6897 10.784 19.6134ZM6.72478 16.8446C6.09403 16.2045 5.62901 15.5644 5.28271 14.9242C5.14542 14.6704 5.02546 14.4159 4.92125 14.1608M6.72478 16.8446C6.72478 16.8446 6.36408 15.4978 6.36408 14.5635C6.36408 13.4814 6.72478 13.1207 6.72478 12.0386C6.72478 10.9564 7.66349 12.9081 7.8069 13.8421C8.01631 15.2059 6.72478 16.8446 6.72478 16.8446ZM6.72478 16.8446C7.04167 17.1663 7.40039 17.4879 7.8069 17.8095M7.8069 17.8095C7.8069 17.8095 5.87285 17.0884 4.56054 17.4492C3.95311 17.6161 3.38698 18.1706 2.75701 18.1706C1.67489 18.1706 4.49366 19.0626 5.64266 18.892C6.57743 18.7532 7.8069 17.8095 7.8069 17.8095ZM4.92125 14.1608C4.92125 14.1608 2.87184 14.0535 2.0357 13.1207C1.23235 12.2245 0.59281 9.51361 1.31432 10.235C2.03583 10.9564 2.39661 10.9564 3.11772 11.6778C3.83882 12.3993 4.92125 14.1608 4.92125 14.1608ZM4.92125 14.1608C4.43922 12.9809 4.29427 11.7883 4.33036 10.5957M4.33036 10.5957C4.35222 9.87337 4.4405 9.15103 4.56054 8.43149C4.56669 8.39465 4.57294 8.35813 4.57929 8.32193M4.33036 10.5957C4.33036 10.5957 4.78423 8.77649 5.64266 8.07078C6.1293 7.67073 6.80367 7.91279 7.08549 7.34937C7.44633 6.62796 7.10293 9.16314 6.36408 9.87432C5.75693 10.4587 4.33036 10.5957 4.33036 10.5957ZM4.57929 8.32193C4.57929 8.32193 3.54172 7.88813 3.11772 7.34937C2.41536 6.45691 2.52885 4.00758 2.75701 4.46372C3.11786 5.18513 3.42895 5.33408 3.83927 5.90654C4.47672 6.7959 4.57929 8.32193 4.57929 8.32193Z" stroke="black" stroke-width="0.5"/>
        <path d="M23.444 20.3348C23.7784 20.6955 24.1945 21.1239 24.8081 21.4169C26.2121 22.0874 27.9342 21.5372 29.1365 21.4169C30.3389 21.2967 27.5346 20.5371 26.6116 20.3348C25.3954 20.0682 23.444 20.3348 23.444 20.3348C24.0728 20.0581 24.6449 19.8051 25.0773 19.6134C25.5763 19.3922 25.8895 19.2527 25.8895 19.2527C26.7314 18.7716 27.4464 18.2905 28.0544 17.8095C28.0544 17.8095 29.2839 18.7532 30.2187 18.892C31.3677 19.0626 34.1864 18.1706 33.1043 18.1706C32.4744 18.1706 31.9082 17.6161 31.3008 17.4492C29.9885 17.0884 28.0544 17.8095 28.0544 17.8095C28.4609 17.4879 28.8197 17.1663 29.1365 16.8446C29.7673 16.2045 30.2323 15.5644 30.5786 14.9242C30.7159 14.6704 30.8359 14.4159 30.9401 14.1608C30.9401 14.1608 32.9895 14.0535 33.8256 13.1207C34.629 12.2245 35.2685 9.51361 34.547 10.235C33.8255 10.9564 33.4647 10.9564 32.7436 11.6778C32.0225 12.3993 30.9401 14.1608 30.9401 14.1608C31.4221 12.9809 31.5671 11.7883 31.531 10.5957C31.5091 9.87337 31.4208 9.15103 31.3008 8.43149C31.2946 8.39465 31.2884 8.35813 31.282 8.32193C31.282 8.32193 32.3196 7.88813 32.7436 7.34937C33.446 6.45691 33.3325 4.00758 33.1043 4.46372C32.7435 5.18513 32.4324 5.33408 32.0221 5.90654C31.3846 6.7959 31.282 8.32193 31.282 8.32193C30.9913 6.66403 30.4121 5.52865 30.2179 5.18513C30.2179 5.18513 30.4455 4.06291 30.2179 3.38158C29.8565 2.29944 27.693 1.57805 27.6937 1.21736C27.6957 0.231308 27.5941 2.86992 28.0537 3.74229C28.583 4.74681 30.2179 5.18513 30.2179 5.18513C30.4121 5.52865 30.9913 6.66403 31.282 8.32193C31.2884 8.35813 31.2946 8.39465 31.3008 8.43149C31.4208 9.15103 31.5091 9.87337 31.531 10.5957C31.531 10.5957 31.0771 8.77649 30.2187 8.07078C29.732 7.67073 29.0577 7.91279 28.7758 7.34937C28.415 6.62796 28.7584 9.16315 29.4973 9.87432C30.1044 10.4587 31.531 10.5957 31.531 10.5957C31.5671 11.7883 31.4221 12.9809 30.9401 14.1608C30.8359 14.4159 30.7159 14.6704 30.5786 14.9242C30.2323 15.5644 29.7673 16.2045 29.1365 16.8446C29.1365 16.8446 29.4973 15.4978 29.4973 14.5635C29.4973 13.4814 29.1365 13.1207 29.1365 12.0386C29.1365 10.9564 28.1978 12.9081 28.0544 13.8421C27.845 15.2058 29.1365 16.8446 29.1365 16.8446C28.8197 17.1663 28.4609 17.4879 28.0544 17.8095C27.4464 18.2905 26.7314 18.7716 25.8895 19.2527C25.8895 19.2527 25.5763 19.3922 25.0773 19.6134C25.0773 19.6134 25.0757 19.6051 25.0729 19.5895C25.1908 19.44 25.9451 18.7268 26.2509 17.8095C26.6116 16.7274 26.2509 15.9149 26.2509 15.2849C26.2509 14.2028 25.3354 16.2887 25.0773 17.0884C24.7964 17.9592 25.0368 19.3879 25.0729 19.5895C25.0517 19.6164 25.0511 19.625 25.0773 19.6134C24.6449 19.8051 24.0728 20.0581 23.444 20.3348Z" fill="#F3F3F3"/>
        <path d="M15.0683 23.7245C15.2452 23.7245 21.2983 21.279 23.444 20.3348M30.2179 5.18513C30.2179 5.18513 30.4455 4.06291 30.2179 3.38158C29.8565 2.29944 27.693 1.57805 27.6937 1.21736C27.6957 0.231308 27.5941 2.86992 28.0537 3.74229C28.583 4.74681 30.2179 5.18513 30.2179 5.18513ZM30.2179 5.18513C30.4121 5.52865 30.9913 6.66403 31.282 8.32193M23.444 20.3348C23.7784 20.6955 24.1945 21.1239 24.8081 21.4169C26.2121 22.0874 27.9342 21.5372 29.1365 21.4169C30.3389 21.2967 27.5346 20.5371 26.6116 20.3348C25.3954 20.0682 23.444 20.3348 23.444 20.3348ZM23.444 20.3348C24.0728 20.0581 24.6449 19.8051 25.0773 19.6134M25.0773 19.6134C25.5763 19.3922 25.8895 19.2527 25.8895 19.2527C26.7314 18.7716 27.4464 18.2905 28.0544 17.8095M25.0773 19.6134C25.0773 19.6134 24.7745 18.0269 25.0773 17.0884C25.3353 16.2887 26.2509 14.2028 26.2509 15.2849C26.2509 15.9149 26.6116 16.7274 26.2509 17.8095C25.8902 18.8916 24.9053 19.6897 25.0773 19.6134ZM29.1365 16.8446C29.7673 16.2045 30.2323 15.5644 30.5786 14.9242C30.7159 14.6704 30.8359 14.4159 30.9401 14.1608M29.1365 16.8446C29.1365 16.8446 29.4973 15.4978 29.4973 14.5635C29.4973 13.4814 29.1365 13.1207 29.1365 12.0386C29.1365 10.9564 28.1978 12.9081 28.0544 13.8421C27.845 15.2059 29.1365 16.8446 29.1365 16.8446ZM29.1365 16.8446C28.8197 17.1663 28.4609 17.4879 28.0544 17.8095M28.0544 17.8095C28.0544 17.8095 29.9885 17.0884 31.3008 17.4492C31.9082 17.6161 32.4744 18.1706 33.1043 18.1706C34.1864 18.1706 31.3677 19.0626 30.2187 18.892C29.2839 18.7532 28.0544 17.8095 28.0544 17.8095ZM30.9401 14.1608C30.9401 14.1608 32.9895 14.0535 33.8256 13.1207C34.629 12.2245 35.2685 9.51361 34.547 10.235C33.8255 10.9564 33.4647 10.9564 32.7436 11.6778C32.0225 12.3993 30.9401 14.1608 30.9401 14.1608ZM30.9401 14.1608C31.4221 12.9809 31.5671 11.7883 31.531 10.5957M31.531 10.5957C31.5091 9.87337 31.4208 9.15103 31.3008 8.43149C31.2946 8.39465 31.2884 8.35813 31.282 8.32193M31.531 10.5957C31.531 10.5957 31.0771 8.77649 30.2187 8.07078C29.732 7.67073 29.0577 7.91279 28.7758 7.34937C28.415 6.62796 28.7584 9.16314 29.4973 9.87432C30.1044 10.4587 31.531 10.5957 31.531 10.5957ZM31.282 8.32193C31.282 8.32193 32.3196 7.88813 32.7436 7.34937C33.446 6.45691 33.3325 4.00758 33.1043 4.46372C32.7435 5.18513 32.4324 5.33408 32.0221 5.90654C31.3846 6.7959 31.282 8.32193 31.282 8.32193Z" stroke="black" stroke-width="0.5"/>
      </svg>
    </div>
    <div class="card__inner">
      <div class="card__inner-line">
        <p class="card__name">{{ product.name }}</p>
        <div class="card__rating">
          <svg v-for="idx in 5" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 17L5.5 9H1L5.5 1H11.5L8.5 6H12L3 17Z" :fill="rating >= idx ? 'white' : ''" stroke="white"/>
          </svg>
        </div>
      </div>
      <div class="card__price">
        <img src="@icons/currency.svg" alt="currency">
        {{ product.price }}
      </div>
      <div class="card__inner-line">
        <button class="card__button" @click="overwriteCart">{{ isProductInCart ? t('buttons.removeFromCart') : t('buttons.addToCart') }}</button>
        <p class="card__tech">HTML | CSS | JS</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";
import {computed} from "vue";
import {useWishlistStore} from "@/stores/wishlist.js";
import {ElNotification} from "element-plus";
import {Wishlist} from "@/core/api/wishlist.js";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useRouter} from "vue-router";
import {Orders} from "@/core/api/orders.js";

const props = defineProps({
  product: Object
})

const {t} = useI18n()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const router = useRouter()

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder ? cartStore.currentOrder.uuid : null
})
const wishlistUuid = computed(() => {
  return wishlistStore.wishlist ? wishlistStore.wishlist.uuid : ''
})
const user = computed(() => {
  return authStore.user ? authStore.user : null
})
const rating = computed(() => {
  return props.product.feedbacks.edges.length ? props.product.feedbacks.edges[0].node.rating : 3;
})

const isProductInCart = computed(() => {
  return cartStore.currentOrder?.orderProducts?.edges.find((prod) => prod.node.product.uuid === props.product.uuid)
})
const isProductInWishlist = computed(() => {
  const el = wishlistStore.wishlist.products?.edges.find(
      (el) => el?.node?.uuid === props.product.uuid
  );

  return !!el;
});

const overwriteCart = async () => {
  if (user.value) {
    if (isProductInCart.value) {
      const res = await Orders.overwriteCart("removeOrderProduct", accessToken.value, orderUuid.value, props.product.uuid);

      cartStore.setCurrentOrders(res.data.removeOrderProduct.order)
    } else {
      const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, props.product.uuid);
      cartStore.setCurrentOrders(res.data.addOrderProduct.order)

      if (res.errors) {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      } else {
        ElNotification({
          message: t('popup.addToCart', { product: props.product.name }),
          type: "success"
        });
      }
    }
  } else {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('awe-user-locale') || 'en-gb'
      }
    })
  }
}

const overwriteWishlist = async () => {
  if (user.value) {
    if (isProductInWishlist.value) {
      const res = await Wishlist.overwriteWishlist('removeWishlistProduct', accessToken.value, wishlistUuid.value, props.product.uuid)
      wishlistStore.wishlist = res.data.removeWishlistProduct.wishlist
    } else {
      const res = await Wishlist.overwriteWishlist('addWishlistProduct', accessToken.value, wishlistUuid.value, props.product.uuid)
      wishlistStore.wishlist = res.data.addWishlistProduct.wishlist

      if (res.data.addWishlistProduct) {
        ElNotification({
          message: t('popup.addToWishlist', { product: props.product.name }),
          type: "success"
        });
      } else {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      }
    }
  } else {
    await router.push({
      name: 'auth-login',
      params: {
        locale: localStorage.getItem('awe-user-locale') || 'en-gb'
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 275px;
  padding: 15px;
  border-radius: 20px;
  border: 2px solid #F00;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  box-shadow: 0 0 10px 1px #F00;

  &__image {
    width: 100%;
    position: relative;

    & img {
      width: 100%;
      height: 150px;
      object-fit: cover;
      border-radius: 15px;
    }

    & svg {
      cursor: pointer;
      position: absolute;
      z-index: 1;
      top: 10px;
      right: 5px;
      transition: 0.2s;
    }
  }

  &__inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    &-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }
  }

  &__name {
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #F3F3F3;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__rating {
    display: flex;
    align-items: center;
  }

  &__price {
    display: flex;
    align-items: center;
    gap: 10px;

    color: #F3F3F3;
  }

  &__button {
    cursor: pointer;
    border-radius: 10px;
    border: 1.5px solid #F3F3F3;
    background-color: transparent;
    padding: 3px 10px;
    box-shadow: 0 0 5px 1px #F3F3F3;
    transition: 0.2s;

    color: #F3F3F3;
    font-size: 13px;

    @include hover {
      background-color: $white;
      color: $black;
    }
  }

  &__tech {
    color: #F3F3F3;
    font-size: 13px;
  }
}
</style>